import React from 'react';
import { TableRow, TableCell, Typography, Box } from '@mui/material';
import { spaces } from '../../assets/styles/themes/tokens';

export type PricingDataProps = {
  label: string;
  price: string;
  previousPrice?: string;
  dataTestId?: string;
};

interface PricingDetailsProps {
  pricingData: PricingDataProps[];
}

const PricingDetails: React.FC<PricingDetailsProps> = ({ pricingData }) => {
  return (
    <>
      {pricingData.map((item, index) => {
        const isLastItem = index === pricingData.length - 1; // variable to check if the item is the last one

        return (
          <TableRow key={index}>
            <TableCell
              sx={{
                paddingX: 0,
                borderBottom: isLastItem ? 'none' : undefined,
              }}
            >
              <Typography
                variant='body2'
                sx={isLastItem ? { fontWeight: 500, lineHeight: '24px' } : {}}
              >
                {item.label}
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                paddingX: 0,
                borderBottom: isLastItem ? 'none' : undefined,
              }}
              align='right'
            >
              {isLastItem && item.previousPrice ? (
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: spaces.xs, justifyContent: 'flex-end' }}>
                  <Typography
                    data-testid='previous-price'
                    variant='body2'
                    sx={{ textDecoration: 'line-through', lineHeight: '24px' }}
                  >
                    {item.previousPrice}
                  </Typography>
                  <Typography
                    variant='body2'
                    sx={{ fontWeight: 500, lineHeight: '24px' }}
                    data-testid={item.dataTestId}
                  >
                    {item.price}
                  </Typography>
                </Box>
              ) : (
                <Typography
                  variant='body2'
                  sx={isLastItem ? { fontWeight: 500, lineHeight: '24px' } : {}}
                  data-testid={item.dataTestId}
                >
                  {item.price}
                </Typography>
              )}
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
};

export default PricingDetails;
